import { render, staticRenderFns } from "./crosssell-item.vue?vue&type=template&id=7c6d731a&"
import script from "./crosssell-item.vue?vue&type=script&lang=js&"
export * from "./crosssell-item.vue?vue&type=script&lang=js&"
import style0 from "./crosssell-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DynamicImg: require('/opt/build/repo/storefront/components/legacy/global/dynamic-img.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default,ProductName: require('/opt/build/repo/storefront/components/legacy/global/product-name.vue').default,BestsellerButtons: require('/opt/build/repo/storefront/components/legacy/global/bestseller-buttons.vue').default,ReviewStars: require('/opt/build/repo/storefront/components/molecules/Review/ReviewStars.vue').default,PrimaryButton: require('/opt/build/repo/storefront/components/atoms/Button/PrimaryButton.vue').default})
